"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toKey = exports.fromKey = exports.types = void 0;
var types;
(function (types) {
    types["COMMUNITY"] = "community";
    types["INCENTIVE"] = "incentive";
    types["ARTICLE"] = "article";
    types["NEWS"] = "news";
    types["COMMUNITY_ARTICLE"] = "community_article";
    types["PRODUCT_RESOURCE"] = "product_resource";
    types["STRIPE_PRICE"] = "stripe_price";
    types["STRIPE_PRODUCT"] = "stripe_product";
    types["STRIPE_SUBSCRIPTION"] = "stripe_sub";
    types["OFFER"] = "offer";
    types["ORG_COMMUNITY"] = "org_community";
    types["USER_LIST_ITEM"] = "user_list_item";
    types["USER_PROFILE"] = "user_profile";
    types["LEAD"] = "lead";
    types["TASK_TEMPLATE"] = "task_template";
    types["ORG"] = "org";
    types["CONTRIBUTION"] = "contribution";
    types["OWNER"] = "owner";
    types["MODERATOR"] = "moderator";
    types["CONTRIBUTOR"] = "contributor";
    types["BLOCKED"] = "blocked";
})(types = exports.types || (exports.types = {}));
const fromKey = (str) => {
    const [type, id] = str.split(':');
    return { type, id };
};
exports.fromKey = fromKey;
const toKey = (type, id) => `${type}:${id}`;
exports.toKey = toKey;
